module.exports = __webpack_public_path__ + "static/media/icon-2.609d2db3.svg";